var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app", view: "app", "extension-name": "app" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _c(_vm.currentPage, {
            tag: "component",
            staticClass: "page-container",
            attrs: { currentAccountId: _vm.currentAccountId },
            on: {
              accountChanged: _vm.updateCurrentAccountId,
              notify: _vm.notify
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("notification-popup", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.notificationShow,
            expression: "notificationShow"
          }
        ],
        attrs: {
          title: _vm.notificationTitle,
          message: _vm.notificationMessage
        },
        model: {
          value: _vm.notificationShow,
          callback: function($$v) {
            _vm.notificationShow = $$v
          },
          expression: "notificationShow"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "login-page-logo-container",
        attrs: { a_id: "login-page-logo-container" }
      },
      [
        _c("div", {
          staticClass: "login-page-logo-center",
          attrs: { a_id: "login-page-logo-center" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e7f006c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7f006c","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/App.vue
// module id = 459
// module chunks = 0